import React from "react";
import SearchIcon from "../../../assets/svgs/Search";
import SortAscending from "../../../assets/svgs/SortAscending";
import SortDescending from "../../../assets/svgs/SortDescending";
import Dotted from "../../../assets/svgs/Dotted";
import Plus from "../../../assets/svgs/Plus";

function User({ online, selected, image, name, shortText, time }) {
  return (
    <div
      className={`${
        selected ? " bg-gray-100 " : " hover:bg-gray-100 "
      } relative flex justify-between mt-2 mb-3 px-5 py-3 cursor-pointer`}
    >
      {selected && (
        <div
          style={{ width: "3.5px" }}
          className="h-full bg-[#BA004F] shadow-xl absolute left-0 top-0"
        />
      )}
      <div className="relative w-10 h-10 rounded-full bg-pink-400 shadow-lg">
        <img
          className="w-10 h-10 object-cover rounded-full"
          src={image}
          alt=""
        />
        {online && (
          <div
            style={{ borderWidth: "3px", width: "12px", height: "12px" }}
            className="border-white rounded-full bg-[#BA004F] absolute bottom-0 right-1"
          />
        )}
      </div>
      <div>
        <p className="text-base w-28 truncate font-medium">{name}</p>
        <p className="text-sm w-20 truncate tracking-wider">{shortText}</p>
      </div>
      <div className="flex flex-col items-end">
        <p className="text-sm tracking-wider">{time}</p>
        <button className="text-right">
          <Dotted />
        </button>
      </div>
    </div>
  );
}

const ChatUsers = () => {
  return (
    <div style={{ height: "600px" }} className="relative sm:w-96 border">
      <button className="hidden sm:flex absolute z-50 inset-x-0 mx-auto -bottom-5 w-9 h-9 rounded-full bg-gradient-to-tr from-pink-500 to-pink-600 text-white shadow-lg items-center justify-center">
        <Plus />
      </button>
      <div className="p-4 shadow-lg">
        <h1 className="text-2xl mb-5">Support Chat</h1>
        <div className="flex justify-between space-x-2">
          <div className="relative">
            <input
              className="pl-10 py-3 focus:outline-gray-400 rounded-md bg-gray-100 shadow"
              type="text"
              placeholder="Search for message"
            />
            <button className="absolute inset-y-0 my-auto left-3">
              <SearchIcon />
            </button>
          </div>
          <div className="space-x-1 flex items-center text-gray-500">
            <button>
              <SortDescending />
            </button>
            <button>
              <SortAscending />
            </button>
          </div>
        </div>
      </div>

      <div
        style={{ height: "450px" }}
        className="overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch"
      >
        <br />
        <div>
          <h2 className="font-medium text-base py-2 px-5">Active</h2>
          <User
            name="Anderson Vanhron"
            shortText="Didn’t see that coming"
            online={true}
            selected={true}
            image="https://images.unsplash.com/photo-1549078642-b2ba4bda0cdb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=144&h=144"
            time="6m ago"
          />
          <User
            name="Sarah Morgan"
            shortText="That’s just amazing!"
            online={true}
            time="13m ago"
          />
          <User
            name="Antalya Simons"
            shortText="I’ll call you in a bit!"
            online={true}
            time="1h ago"
          />
        </div>
        <br />
        <div>
          <h2 className="font-medium text-base py-2 px-5">Conversations</h2>

          <User name="Jesus Bojian" shortText="Didn’t coming" time="1h ago" />

          <User
            name="Benjamin Selmy"
            shortText="Where are we on the project?"
            time="1h ago"
          />
        </div>
      </div>
    </div>
  );
};

export default ChatUsers;
